import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type PluginSettingsChangedEventInit = {
  /** Updated settings. */
  settings?: string;
};

/**
 * An event that is fired when plugin settings are updated.
 * A plugin will not receive this event when settings are updated for any other plugin.
 * No result is expected.
 *
 * @eventName "flotiq.plugin.settings::changed"
 * @memberof FlotiqPlugins.Events
 */
export class PluginSettingsChangedEvent extends IFlotiqPluginEvent {
  constructor(initData?: PluginSettingsChangedEventInit) {
    super(initData);
  }
}
